import { render, staticRenderFns } from "./emailEditDialog.vue?vue&type=template&id=3d6c96d3&scoped=true"
import script from "./emailEditDialog.vue?vue&type=script&lang=js"
export * from "./emailEditDialog.vue?vue&type=script&lang=js"
import style0 from "./emailEditDialog.vue?vue&type=style&index=0&id=3d6c96d3&prod&lang=scss&scoped=true"
import style1 from "./emailEditDialog.vue?vue&type=style&index=1&id=3d6c96d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6c96d3",
  null
  
)

export default component.exports